import { render, staticRenderFns } from "./clientContactInfo.vue?vue&type=template&id=0894a401&scoped=true"
import script from "./clientContactInfo.vue?vue&type=script&lang=js"
export * from "./clientContactInfo.vue?vue&type=script&lang=js"
import style0 from "./clientContactInfo.vue?vue&type=style&index=0&id=0894a401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894a401",
  null
  
)

export default component.exports